let storage: any = localStorage;
export const authToken = {
  getToken: () => {
    const impersonateToken = sessionStorage.getItem("impersonateWorkerToken");
    if (impersonateToken) {
      return impersonateToken;
    }

    return storage.getItem("SalmanToken")
      ? storage.getItem("SalmanToken")
      : null;
  },
  setToken: (token) => storage.setItem("SalmanToken", token),
  clearToken: () => storage.removeItem("SalmanToken"),
};
